import Pagination from '@/util/pagination'

export default function () {
  return {
    specializations: [],
    pagination: new Pagination(),
    showDeleteDialog: false,
    deletingId: null,
  }
}
